import ItemCardBadge from '@/components/GridItemCard/Card/components/ItemCardBadge/ItemCardBadge';
import ItemCardImage from '@/components/GridItemCard/Card/components/ItemCardImage/ItemCardImage';
import ItemCardSaveIcon from '@/components/GridItemCard/Card/components/ItemCardSaveIcon/ItemCardSaveIcon';

export type CardImageProps = {
    enterLinkHoverState: () => void;
    isMobile: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
    showBidStatus: boolean;
};

export const CardImage = ({
    enterLinkHoverState,
    isMobile,
    itemId,
    leaveLinkHoverState,
    showBidStatus,
}: CardImageProps) => {
    return (
        <section
            className="relative aspect-square"
            data-testid="image-container"
            onMouseEnter={enterLinkHoverState}
            onMouseLeave={leaveLinkHoverState}
        >
            <ItemCardBadge
                allowBidding
                itemId={itemId}
                myItemsSavedItemCard={isMobile}
                savedItemsCard
            />
            <span className="absolute top-xs right-xs z-[2] xsMax:top-2xs xsMax:right-[5px]">
                <ItemCardSaveIcon itemId={itemId} />
            </span>
            <div className="[grid-area:itemimage] xsMax:[&_img]:absolute xsMax:[&_img]:inset-0">
                <ItemCardImage
                    alignBannerBottomWithGap
                    itemId={itemId}
                    shouldGiveRangeForMobileSize={isMobile}
                    showBidStatus={showBidStatus}
                    useInFluidGrid
                />
            </div>
        </section>
    );
};
